/* @flow */
// Motivational quotes from GymRadio.com, played between songs (on or off).
import React from 'react'
import { observer, inject } from 'mobx-react'
import Switch from 'rc-switch'
import 'rc-switch/assets/index.css'
import '../AdsPanel/AdsPanel.css'
import { QuoteIcon } from '../AdsPanel/shared'

const MotivationPanel = ({ userStore, onToggleMotivation }) => {
  const enabled = !userStore.disableMotivationQuotes
  return (
    <section className="studio studio--motivation" aria-label="Motivational quotes">
      <div className="studio__screen">
        <header className="studio__header">
          <span className="studio__icon"><QuoteIcon /></span>
          <h2 className="studio__headline">Motivational quotes</h2>
        </header>
        <div className="studio__item">
          <div className="studio__item-text">
            <span className="studio__item-title">{ enabled ? 'On' : 'Off' }</span>
            <span className="studio__item-meta">Short lines from GymRadio.com to keep members going, about every 10 songs</span>
          </div>
          <Switch
            checked={ enabled }
            onChange={ (value) => onToggleMotivation && onToggleMotivation(value) }
            aria-label="Play motivational quotes"
          />
        </div>
      </div>
    </section>
  )
}

export default inject((stores) => ({ userStore: stores.userStore }))(observer(MotivationPanel))
